import { getData } from "utils/Gateway";
import * as url from "helper/UrlHelper";

/**
 * Fetches and returns the details of the currently selected ecosystem.
 * @returns {Promise<Object|null>} The ecosystem details object, or null if not found/error.
 */
export async function exportCurrentEcosystemDetails() {

  const token = localStorage.getItem("token");
  const savedEcosystemId = localStorage.getItem("ecosystem");

  if (!token || !savedEcosystemId) return null;

  try {
    const requestUrl =
      url.API_BASE_URL +
      url.API_GET_ECOSYSTEM_DETAILS +
      `/${savedEcosystemId}` +
      `?token=${token}`;
    const response = await getData(requestUrl);

    if (response.status) {
      return response.data;
    } else {
      // Optionally log error: response.message
      return null;
    }
  } catch (error) {
    // Optionally log error: error.message
    return null;
  }
  
}


